export default function() {
  let $callout = $(".js-callout");
  let $calloutToggle = $(".js-callout__toggle");
  if (localStorage.getItem("calloutClosed") === $callout.data("id")) {
    return
  } else {
    $callout.removeClass("d-none");
    $calloutToggle.on("click", e => {
      $callout.addClass("d-none");
      $(".js-main-nav__menu-list").css("padding-top", "");
      localStorage.setItem("calloutClosed", $callout.data("id"));
    });
  }
}
